export default "__VITE_ASSET__DngzVDny__"